import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { BaseUrl } from "./BasePath";

ReactDOM.render(
  <BrowserRouter basename={`/${BaseUrl}`}>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);

reportWebVitals();
